import React from 'react';
import { format, parseISO, differenceInDays } from 'date-fns';

const dietPlans = {
    'weight_loss': 'Weight loss',
    'pre_diabetes': 'Pre diabetes',
    'muscle_gain': 'Muscle gain',
    'diabetes': 'Diabetes',
    'hypertension': 'Hypertension',
    'pcod': 'PCOD',
    'thyroid': 'Thyroid',
}

const DietPlanCard = ({dietPlan}) => {
    
    // const pEndDate = parseISO(dietPlan.planEndDate);
    // const dateDiff = differenceInDays(pEndDate, new Date());
    // const isSubscription = ['one_month_diet_plan_subscription', 'three_month_diet_plan_subscription', 'six_month_diet_plan_subscription'].includes(dietPlan.dietPlanType);
    let dietPlanType = dietPlan?.assessmentDetails?.planType;
    if(dietPlanType)
        dietPlanType = dietPlans[dietPlanType];
    else
        dietPlanType = 'AI plan'
    
    return (
        <div className='diet-plan-card mb-4 mt-2'>
            <div className="d-flex justify-content-between align-items-center mb-3">
                <div>
                    <div className="diet-plan-card-price">{dietPlanType}</div>
                    <div className="diet-plan-card-price-month">
                        1 month • AI plan  
                    </div>
                </div>
                <div className='justify-content-end'>
                    <span className='diet-plan-card-status status-bg-success'>Active</span>
                </div>
            </div>
            <div className='diet-plan-card-date'>
                <span>Start: {dietPlan.planStartDate && format(parseISO(dietPlan.planStartDate), "dd MMM yyyy")}</span>
                <span className='float-end'>End: {dietPlan.planEndDate && format(parseISO(dietPlan.planEndDate), "dd MMM yyyy")}</span>
            </div>
        </div>
    );
}

export default DietPlanCard;
